import React, { useContext } from "react";
import classnames from "classnames";
import "./index.less";
var StepGroupContext = React.createContext(null);
var Step = function (props) {
    var context = useContext(StepGroupContext);
    var tag = props.tag, checked = props.checked, disabled = props.disabled, stepIndex = props.stepIndex, title = props.title, reverse = props.reverse, completeTime = props.completeTime, currentStep = props.currentStep, checkedSteps = props.checkedSteps, _a = props.prefixCls, prefixCls = _a === void 0 ? "dsm-walkthru" : _a;
    var clickHandle = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        context.onClick && context.onClick(stepIndex);
    };
    var uiTag = "button." + tag + ".steps." + stepIndex;
    var status = checked ? "finished" : ((checkedSteps - currentStep === 0) ? "active" : "wait");
    return (React.createElement("div", { className: prefixCls + "-item " + prefixCls + "-item-" + status + " " + (completeTime ? '' : '') + " " },
        completeTime && React.createElement("div", { className: prefixCls + "-item-time " + (currentStep + 1 === checkedSteps ? '' : 'opacity0') },
            React.createElement("h5", { className: "font-weight-bold" }, title),
            React.createElement("div", { className: "f12" }, completeTime)),
        React.createElement("div", { className: prefixCls + "-" + (reverse ? 'line' : 'tail') }, reverse ? '' : title),
        React.createElement("div", { className: prefixCls + "-icon " + (disabled && 'dsm-walkthru-icon-disabled'), onClick: function (e) {
                return !disabled && clickHandle(e);
            }, "data-one-uiautomation": uiTag }),
        React.createElement("div", { className: prefixCls + "-" + (reverse ? 'tail' : 'line') }, reverse ? title : '')));
};
var Steps = function (props) {
    var _a;
    var tag = props.tag, onChange = props.onChange, _b = props.prefixCls, prefixCls = _b === void 0 ? "dsm-walkthru" : _b, steps = props.steps, reverse = props.reverse;
    var stepsCls = classnames(prefixCls, prefixCls + "-rsp", prefixCls + "-horizontal", (_a = {},
        _a[prefixCls + "-auto-text"] = "autoText",
        _a));
    var checkedSteps = steps.filter(function (x) { return x.checked; }).length;
    return (React.createElement(StepGroupContext.Provider, { value: {
            onClick: onChange,
        } },
        React.createElement("div", { className: "c-walkthru" },
            React.createElement("div", { className: stepsCls }, steps.map(function (child, index) {
                return (React.createElement(Step, { title: child.name, key: index, checked: child.checked, stepIndex: child.id, completeTime: child.completeTime, tag: tag, reverse: reverse, currentStep: index, disabled: checkedSteps - index <= 0, checkedSteps: checkedSteps }));
            })))));
};
export default Steps;
